/**
 * Minimal axios instance for auth-related requests.
 * No store/Redux imports - used to avoid circular dependency with authSlice.
 */
import axios from 'axios';

const baseURL = (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) || 'http://localhost:8002';
const prefix = '/api/v1';

const axiosPublic = axios.create({
  baseURL: `${baseURL}${prefix}`,
  timeout: 30000,
});

export default axiosPublic;
